// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.Entity__Type[data-v-0d2c6ede] {\n    font-weight: 500;\n}\n.Entity__Type-1[data-v-0d2c6ede] {\n    color: #0fa2c1;\n}\n.Entity__Type-2[data-v-0d2c6ede] {\n    color: #de8708;\n}\n.Entity__Type-5[data-v-0d2c6ede], .Entity__Type-6[data-v-0d2c6ede] {\n    color: #9c27b0;\n}\n.Entity__Type-9[data-v-0d2c6ede] {\n    color: #3f9442;\n}\n", ""]);
// Exports
module.exports = exports;
